<template>
  <v-card flat rounded="lg">        
    <v-card-text class="pl-1 pr-1 pt-0">
      <template v-if="autorizados.length > 0">
        <adicionar-autorizado />        
        <v-expansion-panels accordion flat class="mt-3">
          <v-expansion-panel
            v-for="(aut, i) in autorizados"
            :key="i"
            class="grey lighten-4 mb-3 rounded-lg"
          >
            <v-expansion-panel-header>
              <v-list-item>
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title class="font-weight-bold">{{
                    aut.nome
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <p>CPF: {{ aut.cpf }}</p>
                    <p>Data nasc: {{ formatarData(aut.data_nasc) }}</p>
                    <v-chip
                      class="mt-1"
                      small
                      :style="{
                        'background-color': aut.cor_hex,
                        color: 'white',
                      }"
                      >{{ aut.status }}</v-chip
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <remover-autorizado :autorizado="aut" />
                </v-list-item-action>
              </v-list-item>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <div v-html="aut.msg"></div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <v-row v-else class="text-center">        
        <v-col cols="12" class="subtitle-1">
          Nenhuma pessoa está autorizada a comprar a prazo em sua conta
        </v-col>
        <v-col cols="12">
          <v-icon size="50">mdi-account-cancel-outline</v-icon>
        </v-col>
        <v-col cols="12">
          <adicionar-autorizado />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import RemoverAutorizado from "./RemoverAutorizado.vue";
import { dateFormat } from "@/global";
import AdicionarAutorizado from './AdicionarAutorizado.vue';
export default {
  components: { RemoverAutorizado, AdicionarAutorizado },
  computed: {
    ...mapState("configComprasPrazo", ["autorizados"]),
  },
  methods: {
    ...mapActions("configComprasPrazo", ["carregarAutorizados"]),
    formatarData(value) {
      return dateFormat(value);
    },
  },
  async mounted() {
    await this.carregarAutorizados();
  },
};
</script>

<style>
.align-right-icon .v-expansion-panel-header__icon {
  margin-left: auto; /* Move o ícone para a direita */
}
</style>